export default __webpack_public_path__ + "static/778-99ecb8ab3accfd4c5339674f32efd710.gif";